 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		91: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"components-video_module-video_module","4":"ibdPage","5":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"container","11":"fc_executive_board","12":"fc_link-fc_link","13":"post-content-body","14":"aboutUsWpPage","15":"author","16":"category_page","17":"components-not_found_component-not_found_component","18":"components-slug-slug","19":"customCollectionPage","20":"feed","21":"list_page","22":"loginPage","23":"logoutPage","24":"magazineTagPage","25":"magazine_page","26":"myAccountPage","27":"newsletters_page_marketo","28":"notFoundPage","29":"offerPage","30":"playlistIndexPage","31":"playlistPage","32":"podcastPage","33":"post_page","34":"registerPage","35":"resetPasswordPage","36":"sitemapIndex","37":"sitemapPost","38":"splash_page","39":"stories","40":"subscribePage","41":"tagPage","42":"videoIndex","43":"videoPage","44":"views-containers-layouts-blank_layout-blank_layout","45":"views-containers-layouts-web_layout-web_layout","86":"MarketoNewsletterForm","87":"MicCarousel","88":"MicIcon","89":"MicMobileIconCarousel","90":"Success-SubmissionSuccess","92":"applications-most-innovative-companies","93":"brands_that_matter_2021","94":"brands_that_matter_page","95":"categoryLink","96":"components-BackgroundHighlight-BackgroundHighlight","97":"components-MultiTabList-MultiTabList","98":"components-QuickCarousel-QuickCarousel","99":"components-StickyBar-StickyBar","100":"components-all_feed-all_feed","101":"components-categories","102":"components-config-config","103":"components-editor_highlights-editor_highlights","104":"components-finite_scroll","105":"components-footer-footer","106":"components-franchise_intro-franchise_intro","107":"components-ibd_category-ibd_category","108":"components-image-image","109":"components-magazine_archive-magazine_archive","110":"components-masthead-masthead","111":"components-mcp_section-mcp_section","112":"components-mic_mobile_menu-mic_mobile_menu","113":"components-more-stories-component-more-stories-component","114":"components-newsletters-recaptcha","115":"components-notice","116":"components-piano-pianoBottomBanner","117":"components-podcast_tile-podcast_tile","118":"components-podcast_tile-podcast_tile_featured","119":"components-post-content-insert","120":"components-ranked","121":"components-recirc-recirc","122":"components-related_posts-related_posts","123":"components-related_slider-related_slider","124":"components-sectors_list-sectors_list","125":"components-social-social","126":"components-top_50-top_50","127":"components-top_50_shuffle-top_50_shuffle","128":"components-video_megatron-video_megatron","129":"containers-pages-list_landers-bwi-2020","130":"containers-pages-list_landers-ibd-2020","131":"containers-pages-list_landers-mic-2021","132":"content-innovation_festival_banner","133":"content-sponsor_bar","134":"fc-components-main-components","135":"fc-components-main-components-StickyBar-StickyBar","136":"fc-components-main-containers","137":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","138":"fc-components-main-containers-IbdLayout-IbdLayout","139":"fc-components-main-containers-MicLayout-MicLayout","140":"fc-components-main-containers-WciLayout-WciLayout","141":"fc-components-main-utils-ConditionalWrapper","142":"franchises-BtmApplyPage","143":"franchises-BwiApplyPage","144":"franchises-IbdApplyPage","145":"franchises-MicApplyPage","146":"franchises-NbttApplyPage","147":"franchises-WciApplyPage","148":"innovation_by_design_future_page","149":"innovation_by_design_page_franchise","150":"innovation_by_design_page_franchise_2023","151":"layouts","152":"layouts-mcp","153":"nav_main_menu-nav_main_menu","154":"package_article_list_entry","155":"packages-nav-package_sticky_nav","156":"post-content-sidebar","157":"topics"}[chunkId]||chunkId) + "." + {"1":"388cc4fe2125e0b5123a","2":"6aa50d529ff72bc78e9d","3":"9b0fc91d4c2f7c2fd145","4":"b645f9ea14f44c0772ab","5":"8f60def8200f7721fa24","6":"393aadc89606f69af61d","7":"58cfccbfa20ae09374dc","8":"d16f73a58e9bd98645a4","9":"9aa5ac79dcf87a4b6ada","10":"a1fd3ae5c8df367c1be8","11":"69e77947018f6dd6c031","12":"ef9ca6b35c655e05954a","13":"00eefd1743c040270478","14":"528491a987862db8e6b6","15":"8e957d4b5664a0ba9625","16":"14188f6864f5cfc77009","17":"4adb4c2c7f0488a4b595","18":"81886973970d26270f6b","19":"a66385e28f05672dfc65","20":"2f40fcce0e7232ec9e70","21":"b73d58cbec0468e609a8","22":"20b752083c3473eecb97","23":"ead48ef5e4be317c1371","24":"37153b8ac176aa756b0c","25":"fcca7dfa784f4d1b0acb","26":"07214397c5a8f04871ff","27":"b5109d3264f6e59a080e","28":"ffd1a8c0d82931b73492","29":"354a4900ff853f2f7115","30":"abf0f2ab1ac3cd30572b","31":"ef56d878dedf8f44a67a","32":"6b47c4a30d528c3e58e5","33":"bc5c4f5f4c427a1897f0","34":"af7b5c81c955ee83499b","35":"ab89f15382981b9c9b8a","36":"34e91449fb095e7f56c0","37":"247124e1306344573178","38":"23b98ad36e23d1b2c4a0","39":"afccd1019aad0c4bf4dd","40":"2a6e6ddf39ab1c963cbf","41":"86cfda72f4c2c8721047","42":"dd52c96c84ab1bb86b53","43":"af57bccc0c6bc00187b1","44":"605c757c603053300c89","45":"dd57c3a9636e38e7a799","46":"25a16235cb461fb220a6","47":"2097172beac3048c2e89","48":"6b5587f48bcef72b0bc7","49":"ba46f2eb4abc8e3e9fb2","50":"4be6051ee397b97c1b5e","51":"53d9858c359e162a429f","52":"efaf6c5ddabfc5dfe326","53":"066cfaa762ad1618b5f9","54":"a26a0a51e434abc49d1d","55":"7c5e49d1be5161b93f3e","56":"26e677770f54b9098f64","57":"f913eb7473dc2450fa6a","58":"2436a36bba60920db2e1","59":"6e87b6077986d9797c41","60":"3aa0a14f252168f8ff27","61":"29bae1135697ef3f831c","62":"4bfc5528c98934bacde8","63":"e7426e71a567e81db39d","64":"0cb966bab3b227bfaf48","65":"77546854548d5bf6a9d8","66":"78942fe3916e24308f2b","67":"c2a9f1c8e1e3493ca699","68":"5537401a9ca000201b63","69":"1bc99f76c8db9254591e","70":"dc600fb20c2c736f8909","71":"111383b61b5c470b5009","72":"79956ae32c42ccd55e6d","73":"2c5e55599381224e9ca1","74":"983ac1e1f511b1ba3451","75":"a3753402439e85f87f57","76":"2c1472dfd1ed6101768b","77":"48b2346aaa9a26133f8c","78":"c22b2026e519a6ba5b09","79":"eec204840f264dbeb62d","80":"bebf31ae3c923dc679ae","81":"f45009ec3351054467e7","82":"b042d84e843cfeacc27b","83":"e035f50ed0bc2a40b1f3","84":"78a6d691f02c5039ab02","85":"51a6b7d4a408bf2af1aa","86":"55eabd03f85bc1ed5da0","87":"747b31c563c57cdead42","88":"c509e9bad9dfca416151","89":"193077fde1d066ec52d0","90":"fae219b4dcba8e41d8a8","92":"c9b63bfedd35bdbeb2a5","93":"6523081aac866563c6c6","94":"74eda1f0e3782f0c6e0a","95":"9eb7beff6420c6fc9a3f","96":"d46c7b2aca6c1ef03c05","97":"5320934b860d8e7cc483","98":"59c7c0de26dc6f72dd7d","99":"34116eb28050906c4fd8","100":"3d962bf4c0967f87dcbb","101":"a5caad2cb4d2a2cdfc60","102":"d17f3ed8ff9044f83955","103":"30f81a190e40e6d9ad1a","104":"690a292c43f54d69c9f5","105":"7227ff760e85ffc04888","106":"80a92819d16df8752c07","107":"0c2e6063ac3e6def4ba9","108":"7fc1732b961590444fec","109":"542620a0991c085ac6bc","110":"2f3e2dce73ed4b6e759c","111":"1534b82e85aeff40825c","112":"47ab3e8c13541c5e87a6","113":"549fcf28f146dc42253f","114":"9fa7007ffc8894e57dd6","115":"4b545d2a798d2dbe200c","116":"45a70b1def2fd7cff1ae","117":"1e091757ebe0bd659fcd","118":"cb3785da63b10bc46596","119":"f95db833fa25e18f15ff","120":"ba9cba33dbe5c63f8de2","121":"b6a2411779e90766b91b","122":"1f91c5a18e4f4b241459","123":"272f535451a67852a22b","124":"5e0810ed8a49cd48b39f","125":"4c06d97fabe2500b6b52","126":"8c09d9f0312ed4786b07","127":"79e8ec0561e153dad005","128":"a3072e7e43067106ccb9","129":"97c7bff8f5e64da99d55","130":"a8b07691c490cf757ce9","131":"463dcbe7bd65c042a059","132":"ac6c65fbfcca63a43394","133":"c53e46708b4b7f9c348b","134":"f0a383c48dac34151f62","135":"52dd034463af6daf406a","136":"5a4a5902769926dc8737","137":"27c85960e93c7ba07767","138":"ed4a8d92045303c570ce","139":"663e01b708c1ec760fab","140":"6abc16757f5c5bbd75e7","141":"1c00203ec75abd49a634","142":"15e8db5d097ffb4c8bd1","143":"e85c1aaf07ceb9d6808a","144":"f033407da05ba274371d","145":"bf59dc01d9e6d44a8229","146":"0224f463378682dfb38b","147":"9081438e19267b1c1c4a","148":"6ff4d518b231e3cc7081","149":"38ef2a7896f029283d66","150":"776caeae6e4f4dc70a68","151":"36123b3902cf82602c8d","152":"93b4ef5b7254f327497d","153":"d8750a6a4feaeb7496fe","154":"78c1f42d32a25760bf97","155":"c22744a833a1805b247b","156":"a071a521c5c2ef360368","157":"8ef909b4577d7b0991c8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([760,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
